const months = [
  {
    value: 1,
    text: 'Jan',
  },
  {
    value: 2,
    text: 'Feb',
  },
  {
    value: 3,
    text: 'Mar',
  },
  {
    value: 4,
    text: 'Apr',
  },
  {
    value: 5,
    text: 'May',
  },
  {
    value: 6,
    text: 'Jun',
  },
  {
    value: 7,
    text: 'Jul',
  },
  {
    value: 8,
    text: 'Aug',
  },
  {
    value: 9,
    text: 'Sep',
  },
  {
    value: 10,
    text: 'Oct',
  },
  {
    value: 11,
    text: 'Nov',
  },
  {
    value: 12,
    text: 'Dec',
  },
];

export default months;
